import QueryFormBuilder from '@/components/form-builder/query-form-builder.vue'
import EditFormBuilder from '@/components/form-builder/edit-form-builder.vue'
import DetailTableBuilder from '@/components/form-builder/detail-table-builder.vue'

/*
 这是一个列表访问模板，对于标准的表格，可以直接继承使用，一下所有方法和属性捷克再继承类中从新定义，请根据情况使用
*/
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: { QueryFormBuilder, EditFormBuilder, DetailTableBuilder }
})
export default class Table extends Vue {
  // 列表数据
  public tableData: any[] = []
  // 数据总数
  public totalElements = 0
  // 页数
  public pageNumber = 0
  // 页面大小
  public pageSize = 10
  // 详情弹窗每行属性分段，如下：每行分为两段
  public detailTableColsOfRow = 3
  // 详情弹窗显示状态 0/1（关闭/弹出）
  public detailDialogStatus = 0
  // 编辑弹窗每行属性分段，如下：每行分为三段
  public editFormColsOfRow = 3
  // 编辑弹窗显示状态 0/1（关闭/弹出）
  public editDialogStatus = 0
  // 编辑的数据
  public editFormData: any = {}
  // 查询每行属性分段，如下：每行分为两段
  public queryFormColsOfRow = 2
  // 查询数据
  public queryFormData: any = {}

  //查询，编辑，详情，table共同使用的属性列表，请在继承的类中重新定义
  public entityPropertys: any[] = []

  // created 钩子调用
  // created() {
  //   //拉取数据
  //   this.fetchTableData()
  // }

  // 根据entityPropertys字段，查出appearPlace中含有03（查询）的属性
  get queryListPropertys() {
    return this.entityPropertys
      .filter((item: any) => {
        return item.appearPlace.indexOf('03') !== -1
      })
      .map((item: any) => {
        //字典类型字段拼接，请按照各自字典规则进行设置
        if (['05', '09', '10', '11', '12', '13', '14', '25', '26', '30'].includes(item.inputType)) {
          item.propertyName = item.name + '_name'
        } else {
          item.propertyName = item.name
        }
        return item
      })
  }

  //拉取数据，请重写
  fetchTableData() {
    console.log('没有定义fetchTableData()方法，请定义')
  }

  //添加修改数据，请重写
  async saveEditFormData() {
    console.log('没有定义saveEditFormData()方法，请定义')
  }

  //删除数据，请重写
  deleteTableData(row: any) {
    console.log('没有定义deleteTableData()方法，请定义')
  }

  //点击处理，请重写
  handleCurrentChange(row: any) {
    console.log('没有定义列表点击handleCurrentChange()方法，请定义')
  }

  //列表索引
  lineNumber(index: any) {
    return 10 * this.pageNumber + index + 1
  }

  //关闭编辑弹窗
  editDialogClose() {
    this.editDialogStatus = 0
  }

  //关闭详情弹窗
  detailDialogClose() {
    this.detailDialogStatus = 0
  }

  //el-pagination切换页数时触发方法
  tablePaging(pageNumber: any) {
    this.pageNumber = pageNumber - 1
    this.fetchTableData()
  }

  //查询方法
  query() {
    this.pageNumber = 0
    this.fetchTableData()
  }

  //重置方法
  resetForm(formName: any) {
    this.queryFormData = {}
    this.fetchTableData()
  }

  vaildEditForm() {
    return new Promise((resolve, reject) => {
      ;(this.$refs['editForm'] as any).$refs['form'].validate((valid: any) => {
        resolve(valid)
      })
    })
  }
}
